<template>
	<div class="file_exchange wrap_panel">
		<div class="d-flex flex-start w-100">
			<div class="mr-2 hidden-md-down">
					<span class="icon-stack icon-stack-lg">
						<i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
						<i class="ni ni-notebook icon-stack-1x opacity-100 color-white"></i>
					</span>
			</div>
			<div class="d-flex flex-fill">
				<div class="flex-fill">
					<span class="h5">File exchange IMC</span>
				</div>
			</div>
		</div>

		<div class="exchange_body">
			<div class="">
				<ul class="imc_box row">
					<li class="mt-3 mb-3 col-md-4 col-xs-6 col-lg-3 col-xl-2" v-for="icon in icons" v-on:click="set_active(icon)">
						<a href="#" class="user_list bg-primary-500 color-primary-500 active">
							<div class="menu_item menu_item rounded hover-bg shadow-hover text-center shadow-sm border ">
								<div class="icon ">
									<i class="fal " :class="icon.icon"></i>
								</div>
								<div class="content">
									<p class="name">
										{{icon.title}}
									</p>
								</div>
							</div>
						</a>
					</li>
				</ul>
			</div>

			<div class="some_info mt-5 mb-5">
				<f_info></f_info>
			</div>


			<div class="view_type">
				<f_files v-if="cur_view == 'files'"></f_files>
				<f_users v-if="cur_view == 'users'"></f_users>
			</div>
		</div>
	</div>

</template>

<script>
import F_files from "./f_exchange/f_files";
import F_users from "./f_exchange/f_users";
import F_info from "./f_exchange/f_info";
export default {
	name: "filexchange",
	components: {F_info, F_users, F_files},
	data () {
		return {
			'cur_view' : "",
			icons : [
				{
					'icon' : "fa-users",
					'title' : "Користувачi",
					'cur_type' : "users",
				},

				{
					'icon' : "fa-file",
					'title' : "Файли",
					'cur_type' : "files",
				}
			]
		}
	},

	methods : {
		set_active(icon) {
			this.cur_view = icon.cur_type;
		}
	}
}
</script>

<style scoped>

</style>
